import React, { Component } from 'react';
import NavMenu from '../sidebar/navBar';
import SideMenu from '../sidebar/SidebarCustom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import  {listCityCountryStateAction, changeStatusAction} from '../../../actions/Admin/CountryCityAction'
import { notification } from 'antd';
import './../App.css';

class AdminViewCity extends Component { 

    constructor(props) {
        super(props);
        this.state = {
            isOpen: true,
            statusChange:false,
            fieldsList: [],
            code: '',
            sizePerPage: 10,
            fieldSelct: '',
            fieldsCount: "",
            currentPage: 1,
            page:0,
            userType: "company",
            aprStatus:"",
            status:{label:"All",value:"all"},
            statusOption:[
                {label:"All",value:"all"},
                {label:"Approve",value:"approve"},
                {label:"Unapprove",value:"unapprove"},
            ], 
            statusActive:[
                {label:"All",value:"all"},
                {label:"Active",value:"active"},
                {label:"Inactive",value:"inactive"},
            ] 

        }
    }

    componentWillMount() {
        const {page,sizePerPage,userType,status,aprStatus} = this.state
        this.userList(page,sizePerPage,userType,status,aprStatus);
    } 

    componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.cityStateData && nextProps.cityStateData.data && Array.isArray(nextProps.cityStateData.data.data)) {
            this.setState({
                fieldsCount: nextProps.cityStateData.data.totalCount,
                fieldsList: nextProps.cityStateData.data.data
            })
        }

        if(nextProps.responseStatusChnage&&nextProps.responseStatusChnage.statusCode===200&&this.state.statusChange===true){
            notification.success({
                message: nextProps.responseStatusChnage.msg,
                className:'successNotification',
                duration: 3
            });
            this.setState({
                statusChange:false
            })
            this.componentWillMount();
        }
    }

    userList=(page,limit,type,status,aprStatus)=>{
        if(status.value==="all"){
            status=""
        }else{
            status=status.value
            console.log("status", status);
        } 
        if(aprStatus.value==="all"){
            aprStatus=""
        }else{
            aprStatus=aprStatus.value
            console.log("status", status);
        }

        let reqObj = {
            "limit":limit,
            "offset":page,
            "order": "createdAt",
            "direction": "desc",
            "search": "",
            "status": status,
            "type":type,
            "approvedStatus":aprStatus
        }
        this.props.listCityCountryStateAction(reqObj);
    }

    handleChangeSelect = (name, value) => {
        const {page,sizePerPage,userType,status,aprStatus} =this.state
        this.setState({
            [name]: value
        });
         var values  ="";
        var aprStatus2 ="";
        if(name==="aprStatus"){
            aprStatus2 =value
            values = status ;
        }else{
            aprStatus2 =aprStatus
            values = value ;
        }
        this.userList(page,sizePerPage,userType,values,aprStatus2);
    }

    handleSelect = (e,type) => {
        const {page,sizePerPage,status} =this.state
        type=type.toLowerCase()
        this.setState({ userType: type,key:e });
        this.userList(page,sizePerPage,type,status);
    }

    sizePerPageListChange(sizePerPage) {
        const {page,userType,status} =this.state
        this.setState({
            sizePerPage:sizePerPage
        })
        this.userList(page,sizePerPage,userType,status);
    }

    onPageChange(page, sizePerPage) {
        this.setState({
            currentPage: page
        })
        let reqObj = {
            "limit": 10,
            "offset": page - 1,
            "order": "name",
            "direction": "desc",
            "search": "",
            "status": ""
        }
        this.props.listCityCountryStateAction(reqObj);
    }

    chnageStatus=(data,type,value)=>{
        console.log("data", data);

       let reqObj={
        id:data._id,
        type:"city"
       }
        if(data.status==="active"){
            reqObj.status="inactive"        
        }else{
            reqObj.status="active"        
        }
       
        this.setState({
            statusChange:true
        })
        this.props.changeStatusAction(reqObj)
    }

    emailWindowUser(cell, row, rowIndex){
        return(
            <a href={"mailto:"+row.email}>{row.email}</a>
        )
    }
    
    StatusArow(cell, row, rowIndex){
        return(
            <button className="button-clickscity">{row.approvedStatus}</button>
        )
    }

    counrtryRow(cell, row, rowIndex){
        if(row && row.countryData && row.countryData.countryName && row.countryData.countryName.length>0){

            return(
                <div>{row.countryData.countryName[0].label}</div>
            )
        }
    }

    counrtryStateRow(cell, row, rowIndex){
        if(row && row.stateData && row.stateData.stateName&& row.stateData.stateName.length>0){
            return(
                <div>{row.stateData.stateName[0].label}</div>
            )
        }
    }

    CityShowState(cell, row, rowIndex){
        if(row && row.cityName){
            return(
                <div >{row.cityName}</div>
            )
        }
    }
    
    StatusBrow(cell, row, rowIndex){
        if(row){
            return(
                <button className="button-clickscity" onClick={this.chnageStatus.bind(this,row,"status")}>{row.status}</button>
            )
        }
    }

    render() {
        const {fieldsList, sizePerPage, currentPage} = this.state;
        var options = {
            onPageChange: this.onPageChange.bind(this),
            onSizePerPageList: this.sizePerPageListChange.bind(this),
            sizePerPage:sizePerPage,
            paginationPosition: 'bottom', // default is bottom, top and both is all available
            alwaysShowAllBtns: true,
            page: currentPage,
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last',
        };

        return (
            <div className="wrapper">
                <SideMenu toggle={this.toggle} isOpen={this.state.isOpen}/>
                <div id="content">
                    <NavMenu toggle={this.toggle} isOpen={this.state.isOpen}/>
                    <div className="custom-table-wrapper">
                        <BootstrapTable data={fieldsList} options={options} remote={true} fetchInfo={{dataTotalSize: this.state.fieldsCount}} pagination> 
                            <TableHeaderColumn hidden={true} dataField='_id' isKey>object ID</TableHeaderColumn>
                            <TableHeaderColumn width='230' tdAttr={{'data-attr':'Country' }} dataField=''  dataFormat={this.counrtryRow.bind(this)}>Country</TableHeaderColumn>
                            <TableHeaderColumn width='230' tdAttr={{'data-attr':'Email' }} dataField='' dataFormat={this.counrtryStateRow.bind(this)}>State</TableHeaderColumn>
                            <TableHeaderColumn width='230' tdAttr={{'data-attr':'Status' }} dataField='' dataFormat={this.CityShowState.bind(this)}>City</TableHeaderColumn>
                            <TableHeaderColumn width='230' tdAttr={{'data-attr':'Status' }} dataField='status' dataFormat={this.StatusBrow.bind(this)}>Status</TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        cityStateData: state.CountryStaeCity.response,
        responseStatusChnage: state.CountryStaeCity.responseStatusChnage,
    };
}

export default withRouter(connect(mapStateToProps, {
    listCityCountryStateAction,
    changeStatusAction,
})(AdminViewCity));


// WEBPACK FOOTER //
// ./src/components/Admin/City/ViewCity.js